import React, { useState } from "react";
import "./style.css";
import { LightText } from "../ui/Text";

interface ToggleSwitchProps {
  showLabel: boolean;
  initialState?: boolean;
  onChange: (toggleId: string, value: boolean) => Promise<boolean>;
  toggleId: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ showLabel, initialState = false, onChange, toggleId }) => {
  const [isLoading, setIsLoading] = useState(false);

  const toggleSwitch = async () => {
    setIsLoading(true);
    const newState = !initialState;
    await onChange(toggleId, newState);
    setIsLoading(false);
  };

  return (
    <div className="flex items-center">
      {showLabel && <LightText className=" pr-2 !text-text-default" text={initialState ? "Enabled" : "Disabled"} />}
      <input type="checkbox" className="toggle" id={toggleId} onChange={toggleSwitch} checked={initialState} disabled={isLoading} />
      <div className="toggle-checkbox">
        <label htmlFor={toggleId}></label>
      </div>
    </div>
  );
};

export default ToggleSwitch;
